export default {
  translation: {
    nav: {
      home: 'Ana Sayfa',
      trips: 'Seyahatler',
      aboutUs: 'Hakkımızda',
      alerts: 'Bildirimler',
      wishlist: 'Favoriler',
      language: 'Dil',
      profile: 'Profil',
      settings: 'Ayarlar',
      signIn: 'Giriş Yap',
      signUp: 'Kayıt Ol'
    },
    hero: {
      title: 'Uganda\'yı Keşfet',
      subtitle: 've ötesi',
      description: 'Afrika\'nın İncisini uzman yerel rehberlerle keşfedin. Uganda\'nın nefes kesen manzaralarında ve canlı kültüründe unutulmaz deneyimler sizi bekliyor.',
      searchPlaceholder: 'Nereye gitmek istiyorsunuz?',
      categories: {
        all: 'Tümü',
        wildlife: 'Vahşi Yaşam',
        safari: 'Safari',
        cultural: 'Kültürel',
        adventure: 'Macera',
        birding: 'Kuş Gözlemciliği'
      }
    },
    common: {
      from: 'başlayan fiyatlarla',
      reviews: 'yorum',
      viewMore: 'Daha fazla',
      book: 'Rezervasyon',
      seeAll: 'Tümünü gör',
      loading: 'Yükleniyor...'
    }
  }
};